module.exports = __webpack_public_path__ + "static/media/Platformicon01.b2ab6fc3.png";